import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import SegmentRoute from "@/pages/SegmentRoute";

export const Route = createFileRoute("/agente-ia-seguradora")({
  head: () => buildHead({
    title: SEGMENT_BY_SLUG["agente-ia-seguradora"]!.metaTitle,
    description: SEGMENT_BY_SLUG["agente-ia-seguradora"]!.metaDescription,
    path: "/agente-ia-seguradora",
  }),
  component: () => <SegmentRoute slug="agente-ia-seguradora" />,
});
